import axios, { CancelToken } from 'axios';
import moment from 'moment';

import { BillingDashboard, Granularity } from '../models/BillingDashboardModel';

const API_URL = process.env.REACT_APP_API_URL;
const BILLING_DASHBOARD_URL = `${API_URL}/api/billing-dashboard/`;

export interface BillingDashboardParams {
  since: Date;
  until: Date;
  // Without it the backend picks one from the length of the range.
  granularity?: Granularity;
}

// Both dates are whole days, inclusive. Nothing is cached on either side: every
// call reads the figures live.
export function fetchBillingDashboard(
  { since, until, granularity }: BillingDashboardParams,
  cancelToken?: CancelToken
): Promise<{ data: BillingDashboard }> {
  const params: Record<string, string> = {
    since: moment(since).format('YYYY-MM-DD'),
    until: moment(until).format('YYYY-MM-DD'),
  };
  if (granularity) {
    params.granularity = granularity;
  }

  return axios.get<BillingDashboard>(BILLING_DASHBOARD_URL, {
    params,
    cancelToken,
  });
}
